export const STORE_FILTER_SUB_SECTION_GLOBAL = 'global';

export enum EFilterSections {
  executorsLookupsFeedView = 'executorsLookupsFeedView',
  operationalDocumentsView = 'operationalDocumentsView',
  matricesListView = 'matricesListView',
  referencesListView = 'referencesListView',
  digitalQueueView = 'digitalQueueView',
  executionRequestsView = 'executionRequestsView',
  orders = 'orders',
  shipments = 'shipments',
  executionRequestPanelTabRuns = 'executionRequestPanelTabRuns',
  combinedExecutionRequestRuns = 'combinedExecutionRequestRuns',
  combinedOrderRuns = 'combinedOrderRuns',
  orderInfoDrawerTabRuns = 'orderInfoDrawerTabRuns',
  partnershipResources = 'partnershipResources',
  employeesResponsible = 'employeesResponsible',
  selfBilling = 'selfBilling',
}
